// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Kunde } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteKunde(): (id: string) => Promise<Kunde> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).kunden.deleteKunde({ id }),
    [getAPI]
  );
}
